import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import { computed } from '@preact/signals'

import {
	DocsIcon,
	FeedbackIcon,
	HorizontalDivider,
	LinkGoToIcon,
	Typography
} from 'components/UI'
import { userInformationState } from 'state'

import { SignOutButton } from './SignOutButton'

const usernameToDisplay = computed(() => {
	if (
		userInformationState.peek()?.firstName &&
		userInformationState.peek()?.lastName
	) {
		return `${userInformationState.peek()!.firstName[0]}
					${userInformationState.peek()!.lastName[0]}`
	}

	return `${userInformationState.peek()!.userHandler[0]!}`
})

const UserMenu = () => (
	<Popover className='relative'>
		<PopoverButton
			aria-label='Toggle user menu'
			class='block flex h-8 w-8 items-center justify-center rounded-full bg-orange focus-visible:outline-none'
		>
			<Typography
				class='uppercase tracking-[-0.5px]'
				color='text-black-900'
				text={usernameToDisplay}
				variant='text3'
				weight='font-bold'
			/>
		</PopoverButton>

		<PopoverPanel
			anchor='left'
			class='
          sm: absolute z-10 mt-12 w-56
          origin-top transform rounded-md border border-black-500
          bg-black-900
          shadow-lg transition
           duration-200 ease-in-out
					focus:outline-none data-[closed]:-translate-y-1
					data-[closed]:opacity-0
        '
			transition
		>
			<div class='m-4'>
				{userInformationState.peek()?.firstName &&
				userInformationState.peek()?.lastName ? (
					<>
						<Typography
							class='inline-block first-letter:uppercase'
							text={userInformationState.peek()?.firstName}
							variant='text2'
							weight='font-bold'
						/>
						<Typography
							class='ml-1 inline-block first-letter:uppercase'
							text={userInformationState.peek()?.lastName}
							variant='text2'
							weight='font-bold'
						/>
						<Typography
							color='text-black-200'
							text={`@${userInformationState.peek()?.userHandler}`}
							variant='text2'
							weight='font-bold'
						/>
					</>
				) : (
					<Typography
						color='text-black-200'
						text={`@${userInformationState.peek()?.userHandler}`}
						variant='text2'
						weight='font-bold'
					/>
				)}
			</div>

			<HorizontalDivider />

			<ul class='flex flex-col'>
				<li class='group flex h-10 cursor-pointer items-center justify-between px-2.5 text-black-200 hover:bg-black-800 hover:text-black-100'>
					<a
						aria-label='Código Documentation'
						class='flex flex-1 items-center justify-between'
						href='https://docs.codigo.ai/'
						rel='noopener noreferrer'
						target='_blank'
					>
						<div class='flex items-center'>
							<DocsIcon />
							<Typography
								class='ml-3'
								color='text-black-200 group-hover:text-black-100'
								text='Docs'
								variant='text3'
							/>
						</div>
						<LinkGoToIcon />
					</a>
				</li>

				<li class='group flex h-10 cursor-pointer items-center justify-between px-2.5 text-black-200 hover:bg-black-800 hover:text-black-100'>
					<a
						aria-label='Feedback'
						class='flex flex-1 items-center justify-between'
						href='https://x.com/CodigoPlatform'
						rel='noopener noreferrer'
						target='_blank'
					>
						<div class='flex items-center'>
							<FeedbackIcon />
							<Typography
								class='ml-3'
								color='text-black-200 group-hover:text-black-100'
								text='Feedback'
								variant='text3'
							/>
						</div>
						<LinkGoToIcon />
					</a>
				</li>
			</ul>

			<HorizontalDivider />

			<ul class='flex flex-col space-y-2'>
				<li>
					<SignOutButton />
				</li>
			</ul>
		</PopoverPanel>
	</Popover>
)

export { UserMenu }
